import styled from 'styled-components'

export default function InputBase({ children, ...rest }) {
  return <Block {...rest}>{children}</Block>
}

const Block = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  & + & {
    margin-top: calc(100vw * (19 / 375));
  }
`
